import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Redirects /tasks to the viewer's landing page.
 */
const TaskListWrapper = () => {
  // /tasks serves nobody.
  //
  // Procurement and legal land on their own queue at /dashboard, which the
  // sidebar labels "My tasks" — a second one here would compete with it.
  // Super admin and management are not meant to have a personal queue at all:
  // super admin owns nothing (my-queue reports 0 for them by design) and
  // management is not authorized on GET /api/dashboard/tasks, so the page
  // rendered an empty table off the back of a 403.
  //
  // The route is kept as a redirect rather than removed so an old bookmark
  // lands somewhere useful instead of on Not Found.
  return <Navigate to="/dashboard" replace />;
};

export default TaskListWrapper;

